export const peopleSearchKeys = {
  searchPeople: () => ['searchPeople'],
  detail: (
    search: string,
    filterSelf: boolean = false,
    notIncludingIds: number[] = [],
  ) => [
    ...peopleSearchKeys.searchPeople(),
    search,
    filterSelf,
    ...notIncludingIds,
  ],
  moduleList: (search: string, order: any, orderBy: any) => [
    ...peopleSearchKeys.searchPeople(),
    search,
    order,
    orderBy,
  ],
  acknowledgementsSearchPeople: (
    search: string,
    filterSelf: boolean = false,
    notIncludingIds: number[] = [],
  ) => [
    ...peopleSearchKeys.searchPeople(),
    'acknowledgements',
    search,
    filterSelf,
    ...notIncludingIds,
  ],
  searchGroupParticipants: (
    search: string,
    filterSelf: boolean = false,
    notIncludingIds: number[] = [],
  ) => [
    ...peopleSearchKeys.searchPeople(),
    'groupParticipants',
    search,
    filterSelf,
    ...notIncludingIds,
  ],
  searchChatUsers: (
    search: string,
    filterSelf: boolean = false,
    notIncludingIds: number[] = [],
  ) => [
    ...peopleSearchKeys.searchPeople(),
    'chatUsers',
    search,
    filterSelf,
    ...notIncludingIds,
  ],
  searchGroup: (name: string) => ['searchGroup', name],
};
